export default "__VITE_ASSET__Cx$xugvY__"